import { ReactNode } from "react";
import AuthHeader from "@/domains/auth/components/AuthHeader.tsx";
import AuthSlider from "@/domains/auth/components/AuthSlider.tsx";

type Props = {
  children: ReactNode;
};

function AuthLayout({ children }: Props) {
  return (
    <div className="card dark:bg-gradient-to-br from-red/20 to-transparent to-30% m-auto  w-[51rem]  p-10 min-h-[47.5rem] max-h-screen  flex gap-10">
      <div className="flex flex-col">
        <AuthHeader />
        <AuthSlider />
      </div>
      <div className="grow flex flex-col">{children}</div>
    </div>
  );
}

export default AuthLayout;
